 
import React from 'react'
import { Image} from 'antd-mobile'
import  "./index.scss";

const Ylso1 = () => {
const token = JSON.parse(localStorage.getItem('cx315_token'))
      
    return <><Image src={token.simg_url}/>
    </>
}

export default Ylso1;